'use client';
import { jsx } from 'react/jsx-runtime';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const PriceBarQuantityAmount = renderWithRef('PriceBarQuantityAmount', null, (e, n)=>{
    let o = new Set([
        'swan-price-bar-button-quantity-amount'
    ]), { children: a } = e;
    return jsx(RenderComp, {
        root: "span",
        forwardedRef: n,
        classNames: o,
        props: e,
        children: a
    });
});

export { PriceBarQuantityAmount };
